import { render, staticRenderFns } from "./classList.vue?vue&type=template&id=66f7c60c&scoped=true&"
import script from "./classList.vue?vue&type=script&lang=ts&"
export * from "./classList.vue?vue&type=script&lang=ts&"
import style0 from "./classList.vue?vue&type=style&index=0&id=66f7c60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f7c60c",
  null
  
)

export default component.exports